import { Check } from 'lucide-react';

const time = (iso: string) =>
  new Intl.DateTimeFormat('de-DE', { hour: '2-digit', minute: '2-digit' }).format(new Date(iso));

/** Gültigkeit der Prüfung: der Server stellt sie 15 Minuten aus, danach ist neu zu prüfen. */
export function PricingPreviewAttestation({ expiresAtUtc }: { expiresAtUtc: string | null }) {
  return (
    <span className="text-forest-deep flex items-center gap-2 text-xs font-bold">
      <Check size={14} strokeWidth={2.6} aria-hidden />
      {expiresAtUtc
        ? `Auf dem Server berechnet · gültig bis ${time(expiresAtUtc)} – danach neu prüfen`
        : 'Auf dem Server berechnet · ohne Freigabe zum Aktivieren'}
    </span>
  );
}
